export const AUTH_EVENTS = {
    notAuthenticated: 'auth-not-authenticated',
    notAuthorized: 'auth-not-authorized',
} as const;
